import { combineReducers } from 'redux'
import createReducer, { createSharedListActions } from '@app-store/slices/sharedLists/create'
import deleteReducer, { deleteSharedListActions } from '@app-store/slices/sharedLists/delete'
import selectCompaniesReducer, { selectCompaniesActions } from '@app-store/slices/sharedLists/selectCompanies'
import rejectCompaniesReducer, { rejectCompaniesActions } from '@app-store/slices/sharedLists/rejectCompanies'
import selectCompaniesByTokenReducer, {
    selectCompaniesByTokenActions
} from '@app-store/slices/sharedLists/selectCompaniesByToken'
import editReducer, { editSharedListActions } from '@app-store/slices/sharedLists/edit'
import editCompaniesReducer, { editCompaniesSharedListActions } from '@app-store/slices/sharedLists/editCompanies'
import listReducer, { listSharedListActions } from '@app-store/slices/sharedLists/list'
import listSearchReducer, { listSearchSharedListActions } from '@app-store/slices/sharedLists/listSearch'
import oneSharedListReducer, { oneSharedListActions } from '@app-store/slices/sharedLists/oneSharedList'
import infoByTokenReducer, { infoByTokenActions } from '@app-store/slices/sharedLists/infoByToken'
import listWithCompanyReducer, { listWithCompanyActions } from '@app-store/slices/sharedLists/listWithCompany'
import SetUnavailableSlotsByTokenReducer, {
    setUnavailableSlotsByTokenActions
} from '@app-store/slices/sharedLists/setUnavailableSlotsByToken'
import getUnavailableSlotsByTokenReducer, {
    getUnavailableSlotsByTokenActions
} from '@app-store/slices/sharedLists/getUnavailableSlotsByToken'
import changeStatusReducer, { changeStatusActions } from '@app-store/slices/sharedLists/changeStatus'

export const sharedListsReducer = combineReducers({
    create: createReducer,
    delete: deleteReducer,
    selectCompanies: selectCompaniesReducer,
    rejectCompanies: rejectCompaniesReducer,
    selectCompaniesByToken: selectCompaniesByTokenReducer,
    edit: editReducer,
    editCompanies: editCompaniesReducer,
    list: listReducer,
    listSearch: listSearchReducer,
    oneSharedList: oneSharedListReducer,
    infoByToken: infoByTokenReducer,
    listWithCompany: listWithCompanyReducer,
    getUnavailableSlotsByToken: getUnavailableSlotsByTokenReducer,
    setUnavailableSlotsByToken: SetUnavailableSlotsByTokenReducer,
    changeStatus: changeStatusReducer
})

export const sharedListsActions = {
    create: createSharedListActions,
    delete: deleteSharedListActions,
    selectCompanies: selectCompaniesActions,
    rejectCompanies: rejectCompaniesActions,
    selectCompaniesByToken: selectCompaniesByTokenActions,
    edit: editSharedListActions,
    editCompanies: editCompaniesSharedListActions,
    list: listSharedListActions,
    listSearch: listSearchSharedListActions,
    oneSharedList: oneSharedListActions,
    infoByToken: infoByTokenActions,
    listWithCompany: listWithCompanyActions,
    getUnavailableSlotsByToken: getUnavailableSlotsByTokenActions,
    setUnavailableSlotsByToken: setUnavailableSlotsByTokenActions,
    changeStatus: changeStatusActions
}
